var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListStartpoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M4.5 15.5H5.5V21.5H4.5V15.5Z",
    fill: "#E4E4E4",
    stroke: "#1D4D08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H20V16H4V2Z",
    fill: "#7CB342"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4H6V14H18V4ZM4 2V16H20V2H4Z",
    fill: "#1D4D08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListStartpoint);
export default __webpack_public_path__ + "static/media/list_startpoint.9664ca68dc9331b5a874bc8d40023e06.svg";
export { ForwardRef as ReactComponent };